module.exports = __webpack_public_path__ + "static/media/ic_notify_black.db98493d.svg";